module.exports = __webpack_public_path__ + "static/media/exchange.8cd92b56.svg";